export const dictionary = {
  // General
  CLOSE: 'Close',
  CONFIRM: 'Confirm',
  CREATE: 'Create',
  EDIT: 'Edit',
  DETAIL: 'Detail',
  DOWNLOAD: 'Download',
  NEW: 'New',
  BACK: 'Back',
  SAVE: 'Save',
  DELETE: 'Delete',
  ADD: 'Add',
  DELETE_MESSAGE: 'Are you sure you want to delete the record?',
  ITEM_DELETED: 'Record deleted',
  LOG_IN: 'Log-in',
  LOG_OUT: 'Log-out',
  SUBMIT: 'Submit',
  NODES: 'Nodes',
  HOME: 'Home',
  // Assets
  ASSET: 'Asset',
  ASSETS: 'Assets',
  CREATE_ASSET: 'Create asset',
  EDIT_ASSET: 'Edit asset',
  DETAIL_ASSET: 'Detail asset',
  ASSET_DELETED: 'Asset deleted',
  ASSET_CREATED: 'Asset created',
  ASSET_EDITED: 'Asset edited',
  // ASSET / COUNTERS
  MONITORED_COUNTER: 'Monitored counter',
  MONITORED_COUNTER_DELETED: 'Counter deleted',
  MONITORED_COUNTER_CREATED: 'Counter created',
  MONITORED_COUNTER_EDITED: 'Counter edited',
  MONITORED_COUNTER_CREATE: 'Create counter',
  MONITORED_COUNTER_EDIT: 'Edit counter',

  MONITORED_COUNTER_SCRAP: 'Monitored counter scrap',
  MONITORED_COUNTER_SCRAP_CREATED: 'Counter scrap created',
  MONITORED_COUNTER_SCRAP_EDITED: 'Counter scrap edited',
  MONITORED_COUNTER_SCRAP_DELETED: 'Counter scrap deleted',
  MONITORED_COUNTER_SCRAP_CREATE: 'Create counter scrap',
  MONITORED_COUNTER_SCRAP_EDIT: 'Edit counter scrap',

  MONITORED_STATE: 'Monitored state',
  MONITORED_STATE_DELETED: 'Monitored state deleted',
  MONITORED_STATE_CREATED: 'Monitored state created',
  MONITORED_STATE_EDITED: 'Monitored state edited',
  MONITORED_STATE_CREATE: 'Create monitored state',
  MONITORED_STATE_EDIT: 'Edit monitored state',

  MONITORED_PROCESS_DATA: 'Monitored process data',
  MONITORED_PROCESS_DATA_CREATED: 'Process data created',
  MONITORED_PROCESS_DATA_EDITED: 'Process data edited',
  MONITORED_PROCESS_DATA_DELETED: 'Process data deleted',
  MONITORED_PROCESS_DATA_CREATE: 'Create process data',
  MONITORED_PROCESS_DATA_EDIT: 'Edit process data',

  MONITORED_CYCLE_TIME: 'Monitored cycle',
  MONITORED_CYCLE_TIME_CREATED: 'Cycle created',
  MONITORED_CYCLE_TIME_EDITED: 'Cycle edited',
  MONITORED_CYCLE_TIME_DELETED: 'Cycle deleted',
  MONITORED_CYCLE_TIME_CREATE: 'Create cycle',
  MONITORED_CYCLE_TIME_EDIT: 'Edit cycle',

  // Opc clients
  OPCCLIENT: 'OPC client',
  CREATE_OPCCLIENT: 'Create OPC client',
  EDIT_OPCCLIENT: 'Edit OPC client',
  OPCCLIENT_DELETED: 'OPC client deleted',
  OPCCLIENT_CREATED: 'OPC client created',
  OPCCLIENT_EDITED: 'OPC client edited',
  INSTANCE_NAME: 'Instance name',
  ENDPOINT_ADDRESS: 'Endpoint address ',
  COMMENT: 'Comment',
  // Shifts
  SHIFTS: 'Shifts',
  SHIFT_DELETED: 'Shift deleted',
  SHIFT_CREATED: 'Shift created',
  SHIFT_EDITED: 'Shift edited',
  SHIFT_ADDED: 'Shift added',
  SHIFT_CREATE: 'Create shift',
  SHIFT_ADD: 'Add shift',
  SHIFT_EDIT: 'Edit shift',
  TIME_IS_UTC: 'Time is in UTC',
  // Groups
  GROUPS: 'Groups',
  GROUP_DELETED: 'Group deleted',
  GROUP_CREATED: 'Group created',
  GROUP_EDITED: 'Group edited',
  GROUP_ADDED: 'Group added',
  GROUP_CREATE: 'Create group',
  GROUP_ADD: 'Add group',
  GROUP_EDIT: 'Edit group',
  GROUP_ASSET: 'Asset group',
  // Email reports
  EMAIL_REPORTS: 'Email reports',
  EMAIL_REPORT_DELETED: 'Email report deleted',
  EMAIL_REPORT_CREATED: 'Email report created',
  EMAIL_REPORT_EDITED: 'Email report edited',
  EMAIL_REPORT_ADDED: 'Email report added',
  EMAIL_REPORT_CREATE: 'Create email report',
  EMAIL_REPORT_ADD: 'Add email report',
  EMAIL_REPORT_EDIT: 'Edit email report',
  EMAIL_REPORT_DETAIL: 'Email report detail',
  EMAIL_REPORT_UNMARKED: 'Email report unmarked',
  TIMEZONE: 'Time zone',
  MONDAY: 'Monday',
  TUESDAY: 'Tuesday',
  WEDNESDAY: 'Wednesday',
  THURSDAY: 'Thursday',
  FRIDAY: 'Friday',
  SATURDAY: 'Saturday',
  SUNDAY: 'Sunday',
  NUMBER_OF_DAYS: 'Number of days',
  NUMBER_OF_WEEKS: 'Number of weeks',
  START_OF_WEEK: 'Start of week',
  END_OF_WEEK: 'End of week',
  START_SHIFT: 'Start shift',
  END_SHIFT: 'End shift',
  REPORT_INTERVAL: 'Report interval (start → end)',
  // Email reports asset
  EMAIL_REPORTS_ASSET: 'Email report assset',
  EMAIL_REPORT_ASSET_DELETED: 'Email report asset deleted',
  EMAIL_REPORT_ASSET_CREATED: 'Email report asset created',
  EMAIL_REPORT_ASSET_EDITED: 'Email report asset edited',
  EMAIL_REPORT_ASSET_ADDED: 'Email report asset added',
  EMAIL_REPORT_ASSET_CREATE: 'Create email asset report',
  EMAIL_REPORT_ASSET_ADD: 'Add email asset report',
  EMAIL_REPORT_ASSET_EDIT: 'Edit email asset report',
  EMAIL_REPORT_ASSET_DETAIL: 'Email report asset detail',
  // Dashboards
  DASHBOARDS: 'Dashboards',
  DASHBOARD_DELETED: 'Dashboard deleted',
  DASHBOARD_CREATED: 'Dashboard created',
  DASHBOARD_EDITED: 'Dashboard edited',
  DASHBOARD_ADDED: 'Dashboard added',
  DASHBOARD_CREATE: 'Create dashboard',
  DASHBOARD_ADD: 'Add dashboard',
  DASHBOARD_EDIT: 'Edit dashboard',
  // OPC BUTTON
  OPC_BUTTON_DELETED: 'OPC button deleted',
  OPC_BUTTON_EDITED: 'OPC button edited',
  OPC_BUTTON_ADDED: 'OPC button added',
  // Local user
  LOCAL_USER: 'User',
  LOCAL_USERS: 'Users',
  LOCAL_USER_CREATE: 'Create user',
  LOCAL_USER_EDIT: 'Edit user',
  LOCAL_USER_DETAIL: 'User detail',
  LOCAL_USER_DELTED: 'User deleted',
  LOCAL_USER_CREATED: 'User created',
  LOCAL_USER_EDITED: 'User edited',
  LOCAL_USER_PASSWORD_CHANGED: 'Password changed succesfully',
  // Permissions
  PERMISSIONS: 'Permissions',

  // Performance comment
  PERFORMANCE_COMMENT_CATEGORY: 'Performance comment category',
  PERFORMANCE_COMMENT_CATEGORY_EDIT: 'Edit performance comment category',
  PERFORMANCE_COMMENT_CATEGORY_CREATE: 'Create performance comment category',
  PERFORMANCE_COMMENT_CATEGORY_EDITED: 'Performance comment category edited',
  PERFORMANCE_COMMENT_CATEGORY_CREATED: 'Performance comment category created',
  PERFORMANCE_COMMENT_CATEGORY_DELETED: 'Performance comment category deleted',
  // Hydra
  HYDRA_MACHINE_NUMBER: 'Hydra machine number',
  HYDRA_MACHINE_NUMBER_REQUIRED: 'Hydra machine number is required',
  HYDRA_SHOW_MACHINE_NUMBER: 'Show hydra machine number',
  HYDRA_SHOW_ORDER_NUMBER: 'Show hydra order number',
  HYDRA_SHOW_TOOL_NUMBER: 'Show hydra tool number',
  HYDRA_SHOW_PART_NUMBER: 'Show hydra part number',
  HYDRA_SHOW_STATUS: 'Show hydra status',
  HYDRA_CHECKBOX_OPTIONS: 'Hydra settings',
  HYDRA_LOAD_PLAN: 'Load hydra plan',
  HYDRA_LOAD_PLAN_MULTIPLICITY: 'Load hydra plan multiplicity',
  HYDRA_LOAD_PLAN_MULTIPLE: 'Load hydra plan multiple',
  // System info
  APP_INFO: 'System info',

  // Browse OPC UA
  BROWSE_OPC_UA: 'Browse OPC UA',

  // Grafana
  GRAFANA_CREATE_FOLDER: 'Create folder',
  GRAFANA_FOLDER_CREATED: 'Folder created',
  GRAFANA_FOLDER_UID: 'Grafana folder uid',

  ADD_FOLDER: 'Option to create folder (available only if folder UId is not set)',

  // Forms
  IS_REQUIRED: 'is required',
};
